module.exports = __webpack_public_path__ + "img/BOC_PLP_top.4d413aee.jpg";